<template>
  <Dialog :title="$t('Categoría')" v-model="show">
    <!-- Contenido del Dialog, Formulario -->
    <template v-slot:content>
      <ValidationObserver ref="form">
        <!-- Nombre de la categoria -->
        <ValidationProvider rules="required|max:50" :name="$t('Nombre').toLowerCase()" v-slot="{ errors, classes }">
          <v-text-field
              :class="classes"
              v-model="categoria.nombre"
              :label="$t('Nombre')"
              hide-details
              outlined dense
          >
          </v-text-field>
          <span class="error--text">{{ errors[0] }}</span>
        </ValidationProvider>

         <!-- Color Picker -->
        <v-dialog v-model="show_color_picker" width="250">
         <template v-slot:activator="{ on }">
           <v-btn :color="categoria.color" dark v-on="on" block class="mt-3"></v-btn>
         </template>
         <v-color-picker @update:color="updateColor" />
        </v-dialog>

        <v-switch :label="$t('Ecommerce')" v-model="categoria.is_ecommerce" />
      </ValidationObserver>
    </template>

    <!-- Acciones de la derecha del dialog -->
    <template v-slot:right-action>
      <v-btn @click="save" small class="primary" :disabled="!allow_save">
        <v-icon small>mdi-content-save</v-icon>
        {{ $t('Guardar') }}
      </v-btn>
    </template>
  </Dialog>
</template>

<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate';

export default {
  name: "FormCategoria",

  // Obtenemos la propiedad que gestionará el dialog desde fuera y la categoria
  props: ['value', 'item', 'method_save'],

  data: () => ({
    // Tipo de categoria
    tipo: undefined,
    show_color_picker: false,
    categoria: {
      color: '#fff000',
      is_ecommerce: true,
    }
  }),

  computed: {
    show: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      }
    },
    centro(){
      return this.$store.state.centro.centro
    },
    allow_save(){
      return !(this.centro.is_categorias_compartidas && !this.centro.is_central);
    },
  },

  methods: {
    /**
     * Guarda el formulario y devuelve al componente padre la categoria
     */
    async save() {
      const form_valid = await this.$refs.form.validate()
      if (form_valid) {
        // Guardamos la nueva categoria
        try {
          const response = await this.$store.dispatch(this.method_save, this.categoria)

	        this.$snotify.success(
		        this.$t("Acción realizada con éxito"),
		        this.$t('Atención {0}', [this.$store.getters['auth/user'].first_name])
	        )
          this.show = false
          this.$emit('on_save', response.data)
        }catch (err){
	        this.$snotify.error(
		        this.$t("Ha ocurrido un error"),
		        this.$t('Atención {0}', [this.$store.getters['auth/user'].first_name])
	        )
        }
      }
    },

    updateColor(color) {
      this.categoria.color = color.hex
    }
  },

  mounted() {
    this.tipo = this.$route.name
    this.categoria = { ... this.item }
  },

  components: {
    ValidationProvider,
    ValidationObserver
  }
}
</script>
